
import React from 'react';
import { bindActionCreators } from 'redux';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage, setActiveLanguage } from 'react-localize-redux';
import Auth from '../services/AuthService';

import { LoginNavBar } from '../components/Navigation';
import { Logo } from '../images';


let LoginLayout = ({ component: Component, ...rest, location, translate, history, currentLanguage, setFlashMessage, setFlashMessageNull, message, setActiveLanguage, current  }) => {

  return(
    <Route {...rest} render={matchProps => {
      const { from } = matchProps.location.state || { from: { pathname: `/${currentLanguage}/services/lines-mobile` } };
      if (rest.computedMatch.params.id) {
        Auth.setToken(rest.computedMatch.params.token)
        localStorage.setItem('userID', rest.computedMatch.params.id);
        return (<Redirect to={from} />);
      } else if (Auth.isLogged()) {
        return (<Redirect to={from} />);
      }
      return (
        <div id="login">
          <LoginNavBar />
          <div className="container text-center">
            <div className="row justify-content-center">
              <div className="col-12">
                <img alt="LOGO" className="logo-height" src={Logo} />
                <div className="page-title"> {translate('sign-in-to-manage-your-account')} </div>
                <Component {...matchProps} />
              </div>
            </div>
          </div>
        </div>
      );
 }}
    />
  );
};
const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code,
  message: state.Flash.message,
});

const mapDispatchToProps = dispatch => bindActionCreators({ setActiveLanguage }, dispatch);

LoginLayout = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginLayout);
export default LoginLayout;



// WEBPACK FOOTER //
// ./src/layouts/LoginLayout.js